export const inputLabel = {
  outlined: {
    transform: 'translate(1rem, 0.6875rem)',
    '&$shrink': {
      transform: 'translate(1rem, -0.4375rem) scale(0.75)',
    },
  },
};
